import { Chip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { HoverModal } from '../hoverModal';
import { MPubCardSimple } from '../mPubCard';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {CardMainContainer} from '../../greySpaceCard.jsx';

const AjaxFunctions = require('../../ajaxFunctions');
const SharedModels = require('../../../../../shared/sharedModels');
const moment = require('moment');

export function ManiaRound(props) {
    let {
        matchData, idRound, maniaData, numMatches, title, isChampionship, isFinal,
        className, topClass, bottomClass, editMode, disableLink, forceShowScore, userVotes, maxVotes
    } = props;
    let [items, setItems] = useState({ groupedItems: {}, regularItems: [] });
    let [isDragging, setIsDragging] = useState(false);
    let date = maniaData[`round${idRound}EndTime`];

    useEffect(() => {
        let hasMoreVotes = userVotes.filter(x => x.idRound === parseInt(idRound)).length < maxVotes
        setItems(getItems(editMode, disableLink, matchData, idRound, maniaData, numMatches,
           isChampionship, isFinal, topClass, bottomClass, userVotes, props.addManiaVote, props.deleteManiaVote, hasMoreVotes
        ));
        if(forceShowScore) maniaData.showScore = true;
    }, [props]);

    let onDragEnd = async (result) => {
        if (!result.destination) {
            return;
        }
        const reorder = (list, startIndex, endIndex) => {
            const result = Array.from(list);
            const [removed] = result.splice(startIndex, 1);
            result.splice(endIndex, 0, removed);
            return { result, removed };
        };
        const newItems = reorder(
            items.regularItems,
            result.source.index,
            result.destination.index
        );

        if (result.destination.droppableId == 'dropTrash') {
            try {
                await AjaxFunctions.removeCardFromPortfolio(maniaData.idIncubator, newItems.removed.id, newItems.removed.cardType)
            } catch (err) {
                console.log("Error removing mania item", err)
            }
        }
        try {
            await AjaxFunctions.updateManiaPositions(maniaData.idIncubator, maniaData.idManiaTournament, newItems.result, 0)
        } catch (err) {
            console.log("Error updating mania positions", err)
        }
    }

    return (
        <div className={className}>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="dropTrash">
                    {(provided, snapshot) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                            {isDragging && <Chip label="Drag To Delete" style={{ width: '100%', backgroundColor: snapshot.isDraggingOver ? '#C0EEEE' : '#E2EEEE' }} />}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
                <div className="round-details">
                    {title}
                    <br />
                    <span className="date">{moment.utc(date).format('l')}</span>
                </div>
                {
                    maniaData.currentRound === parseInt(idRound) &&
                    <div>
                        {maxVotes - userVotes.filter(x => x.idRound === parseInt(idRound)).length} Votes Remaining
                    </div>
                }
                <Droppable droppableId="dropCardList">
                    {(provided, snapshot) => {
                        setIsDragging(snapshot.draggingFromThisWith)
                        return (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {Object.keys(items.groupedItems).map((i) => {
                                    let item = items.groupedItems[i];
                                    let top = item[0] || null;
                                    let bottom = item[1] || null;
                                    return (
                                        <ul key={i} className={`matchup ${isChampionship ? 'championship' : ''}`}>
                                            {top && top.content}
                                            {bottom && bottom.content}
                                        </ul>
                                    )
                                })}
                                {provided.placeholder}
                            </div>
                        )
                    }}
                </Droppable>
            </DragDropContext>
        </div>

    );
}

const getItems =
   (
      editMode, disableLink, matchData, idRound, maniaData, numMatches, isChampionship, isFinal,
      topClass, bottomClass, userVotes, addManiaVoteFunc, deleteManiaVoteFunc, hasMoreVotes
   ) => {
    let groupBy = (key, array) => {
        return array.reduce((objectsByKeyValue, obj) => {
            const value = obj[key];
            objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
            return objectsByKeyValue;
        }, {}
        );
    }

    let roundItems = matchData.filter(x => x.idRound === parseInt(idRound));

    let mappedItems = roundItems.map((cardObject, i) => {
        let card = cardObject;
        let isOnTop = (i % 2) === 0, group = (i / 2) >> 0;
        let maniaClass = (i < (parseInt(numMatches) / 2)) ? topClass : bottomClass;
        let curIdManiaMatch = matchData.find(x => x.idCard === card.id && x.idRound === parseInt(idRound)).idManiaMatch;
        let curManiaItem =
           <ManiaItem
              disableLink={disableLink}
              maniaData={maniaData}
              position={isOnTop ? "top" : "bottom"}
              card={card}
              winType={false}
              className={isChampionship ? topClass : maniaClass}
              hasUserVote={userVotes.some(y => y.idManiaMatch === curIdManiaMatch)}
              addManiaVote={() => addManiaVoteFunc(curIdManiaMatch)}
              deleteManiaVote={() => deleteManiaVoteFunc(curIdManiaMatch)}
              isCurrentRound={maniaData.currentRound === parseInt(idRound)}
              hasMoreVotes={hasMoreVotes}
              isChampionship={isChampionship}
           />;
        return ({
            group, id: i, content: editMode ? <Draggable draggableId={`${i}`} index={i} key={i}>
                {(provided) => (
                   <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                   >
                       {curManiaItem}
                   </div>
                )}
            </Draggable> : curManiaItem
        })
    });
    return { groupedItems: groupBy('group', mappedItems), regularItems: roundItems };
}

function ManiaItem(props) {
    let { card, maniaData, position, winType, className, disableLink, hasUserVote, isChampionship } = props;

    let showScore = maniaData.showScore;
    if (!card) return <li className={`team team-${position} ${className}`}> </li>
    let formattedCard = SharedModels.formatGenericCard(props.card);

    let toggleUserVoteFunction = async (e) =>{
        if(!hasUserVote){
            await props.addManiaVote();
        }
        else{
            await props.deleteManiaVote();
        }
        e.stopPropagation();

    }
    return (
       <div style={{display: 'flex'}}>
            <HoverModal
                linkTo={disableLink
                    ? null
                    : `/incubator?idIncubator=${maniaData.idIncubator}&initialTab=mania&cardType=${card.cardType}&idCard=${card.id}&idSubmitter=${card.idSubmitter}&cModalOpen=1`
                }
                textTitle={
                    <li className={`mania-team team-${position} ${winType}`}>
                        <span style={{ marginRight: '10px' }}>
                            {card.maniaTitle || card.title.substring(0, 15)}
                        </span>
                        {
                            isChampionship &&
                            <div className="pyro">
                                <div className="before"> </div>
                                <div className="after"> </div>
                            </div>
                        }
                        {showScore &&
                        <span className="score">
                            {card.score || 0}
                        </span>}
                    </li>
                }
                titleStyle={{ fontSize: 14, color: '#4457CF' }}
                cardContent={<CardMainContainer disableLink curCard={formattedCard} skipLoading={true}/>}
                hoverAnchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                hoverTransformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                maxWidth={'100%'}
            />
           {
               props.isCurrentRound && (props.hasMoreVotes || hasUserVote) &&
               <FontAwesomeIcon
                  className={`team team-${position} ${winType}`}
                  icon={[`${hasUserVote ? 'fas' : 'far'}`, 'thumbs-up']}
                  onClick={(e) => toggleUserVoteFunction(e)}
                  size={'2x'}
               />
           }
       </div>
    );
}
